import { __awaiter } from "tslib";
import '@slickdeals/blueprint-twig/javascript/components/heading2';
import '@slickdeals/blueprint-twig/javascript/components/link';
import '@slickdeals/blueprint-twig/javascript/components/paragraph';
import '../patterns/featuredOffersTile';
import '../patterns/cashbackOneClickJoin';
import '../patterns/cashbackNonExtensionOffers';
import '../patterns/cashbackUserInfoBar';
import '../patterns/cashbackSteps';
import '../patterns/cashbackInfo';
import '../patterns/cashbackFAQ';
import '../patterns/cashbackBoostedOffers';
import '../patterns/inlineResponse';
import readyState from 'ready-state';
import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import '../../scss/pages/loyaltyCashback.scss';
import HotjarWidgetAdapter from '../hotjar/hotjarWidgetAdapter';
readyState.domready.then(() => __awaiter(void 0, void 0, void 0, function* () {
    new LazyLoad(); // eslint-disable-line no-new
    const hotjar = new HotjarWidgetAdapter();
    hotjar.showHotjarWidget('rewards_for_all_enabled');
}));
